var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-40 -782) translate(40 782) translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.709 5.562l-.7-1.124c-.592-.95-1.904-1.279-2.933-.733-.49.267-1.075.343-1.625.21-.55-.132-1.02-.461-1.308-.915-.185-.288-.285-.617-.289-.952.017-.538-.202-1.06-.607-1.445C11.84.217 11.285 0 10.703 0h-1.41c-.57 0-1.115.21-1.517.584-.402.373-.626.88-.624 1.406-.016 1.089-.975 1.962-2.15 1.962-.363-.003-.718-.095-1.03-.266-1.029-.546-2.341-.218-2.933.733L.288 5.562c-.592.95-.242 2.163.782 2.714.665.356 1.075 1.013 1.075 1.724 0 .711-.41 1.368-1.075 1.724-1.023.547-1.373 1.758-.782 2.705l.71 1.133c.277.463.743.805 1.293.95.55.144 1.14.08 1.64-.179.49-.265 1.076-.337 1.625-.201.548.136 1.016.469 1.298.925.185.289.284.617.288.953 0 1.099.963 1.99 2.151 1.99h1.41c1.184 0 2.146-.885 2.151-1.981-.002-.529.223-1.036.627-1.41.404-.374.953-.583 1.524-.58.362.009.716.1 1.03.266 1.026.547 2.337.224 2.933-.724l.741-1.142c.287-.456.366-.999.219-1.508-.147-.51-.507-.944-1.001-1.207-.494-.263-.854-.697-1.001-1.206-.147-.51-.068-1.052.219-1.508.186-.301.456-.551.782-.724 1.018-.55 1.366-1.757.782-2.705v-.01z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 3.333
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export default ForwardRef;